import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { fetchSubjectStructure } from "@/lib/subjectStructure";
import { SUBJECTS_DATA, type Subject } from "@/data/subjects";

const COMING_SOON_IDS = new Set(
  SUBJECTS_DATA.filter(s => s.comingSoon).map(s => s.id)
);

interface SubjectsContextValue {
  subjects: Subject[];
  loading: boolean;
  error: string | null;
}

const SubjectsContext = createContext<SubjectsContextValue>({
  subjects: [],
  loading: true,
  error: null,
});

export function SubjectsProvider({ children }: { children: ReactNode }) {
  const [subjects, setSubjects] = useState<Subject[]>([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState<string | null>(null);

  useEffect(() => {
    fetchSubjectStructure()
      .then(fetched => setSubjects(fetched.map(s => ({ ...s, comingSoon: COMING_SOON_IDS.has(s.id) }))))
      .catch((e) => setError(e.message ?? "Failed to load subjects"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <SubjectsContext.Provider value={{ subjects, loading, error }}>
      {children}
    </SubjectsContext.Provider>
  );
}

export function useSubjects() {
  return useContext(SubjectsContext);
}
